import { type IProjectSaleItem } from "@/interfaces/api/project-sale-item.interface"
import { BaseRepository } from "@/repositories/base-repository"

export class ProjectSaleItemRepository extends BaseRepository<IProjectSaleItem> {
  protected resourcePath = "administration/projects-sale-items"
}
